module.exports = __webpack_public_path__ + "img/back-icon.77d2345f.png";